import { render, staticRenderFns } from "./m-article-text-wide.vue?vue&type=template&id=2bf29591&scoped=true"
import script from "./m-article-text-wide.vue?vue&type=script&lang=js"
export * from "./m-article-text-wide.vue?vue&type=script&lang=js"
import style0 from "./m-article-text-wide.vue?vue&type=style&index=0&id=2bf29591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf29591",
  null
  
)

export default component.exports